/** @format */
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { getOperations } from '@toucan/services/requests/fixtures';

import { MarketContext } from '@toucan/client/global/market';

/**
 * fetches + returns all operations from the fixture service,
 * including the current operation for activeMarket
 */
export function useOperations() {
    const { activeMarket } = useContext(MarketContext);

    return useQuery({
        queryKey: ['operations'],
        queryFn: getOperations,
        select: (data) => {
            const { operations } = data;

            // select the current operation for the given market
            const operationForMarket = operations.find(
                ({ id }) => id === activeMarket.operation
            );

            return { operations, operation: operationForMarket };
        },
    });
}
